import { apps } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { IAppData, IApps } from "../../models/master/apps";

export default new (class AppService {
  public getApp = async (id: number): Promise<IApiResponse<IAppData>> => {
    try {
      let endPoint = urlBinder(apps.GET_APP, [`${id}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IAppData>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IAppData>;
      } else {
        throw error;
      }
    }
  };

  public getApps = async (
    configUserRole?: number,
    pageBlockId?: number,
    collegeId?:number,
    noOfItems?: number
  ): Promise<IApiResponse<Array<IApps>>> => {
    try {
      let endPoint = urlBinder(apps.GET_ALL_APPS, [
        configUserRole,
        pageBlockId,
        collegeId,
        noOfItems,
      ]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<IApps>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<IApps>>;
      } else {
        throw error;
      }
    }
  };

  public createApp = async (
    data: any
  ): Promise<IApiResponse<boolean | any>> => {
    try {
      let endPoint = apps.CREATE_APP;
      const response = await APIService.postFormData(endPoint, data);
      return response.data as IApiResponse<boolean | any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean | any>;
      } else {
        throw error;
      }
    }
  };

  public updateApp = async (
    data: any,
    id: number
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(apps.UPDATE_APP, [`${id}`]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public updateAppPriority = async (
    data: any
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = apps.UPDATE_APP_PRIORITY;
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public deleteApp = async (id: number): Promise<boolean> => {
    try {
      let endPoint = urlBinder(apps.DELETE_APP, [`${id}`]);
      const response = await APIService.delete(endPoint);
      return response.status === 204 ? true : false;
    } catch (error: any) {
      if (error.response) {
        return false as boolean;
      } else {
        throw error;
      }
    }
  };
})();
